<template>
  <v-row dense class="custom-col-call-search">
    <v-col
      cols="12"
      :class="[
        field.model === 'date' ? 'custom-col-call-search-date-range' : '',
      ]"
      v-for="(field, index) in fields"
      :key="index"
    >
      <v-text-field
        v-if="
          field.model != 'date' &&
          field.model != 'call_time' &&
          field.model != 'call_length'
        "
        v-model="localFilters[field.model]"
        :label="field.label"
        dense
        outlined
        hide-details
        clearable
        @input="emitChange"
        class="call-filter-input"
      />
      <v-menu
        v-if="field.model == 'date'"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        @input="onMenuChange"
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="v-input__control" @click="handleInputControlClickDate">
            <v-text-field
              v-model="displayDate"
              label="日付範囲"
              :append-icon="showCalendarIcon ? 'mdi-calendar-outline' : ''"
              readonly
              dense
              outlined
              hide-details
              clearable
              v-bind="attrs"
              v-on="on"
              class="call-filter-input call-filter-daterange"
              @click:clear="clearDateRange"
              @click:append.stop="menu = true"
            />
          </div>
        </template>

        <v-card>
          <v-date-picker
            v-model="range"
            range
            scrollable
            @input="updateDisplay"
            class="call-filter-date-menu"
            translate="no"
          ></v-date-picker>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="clearDateRange">クリア</v-btn>
            <v-btn text @click="cancelMenu"> キャンセル</v-btn>
            <v-btn color="primary" text @click="applyDate"> 適用</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-menu
        v-if="field.model == 'call_time'"
        v-model="timeMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        @input="onTimeMenuChange"
      >
        <!-- Input to show selected time range -->
        <template v-slot:activator="{ on, attrs }">
          <div
            class="v-input__control"
            @click="handleInputControlClickTimeRange"
          >
            <v-text-field
              v-model="displayTimeRange"
              label="通話時刻帯"
              readonly
              v-bind="attrs"
              v-on="on"
              class="call-filter-input time-range"
              :append-icon="showTimerIcon ? 'mdi-clock-outline' : ''"
              dense
              outlined
              hide-details
              clearable
              @click:clear="clearTimeRange('time')"
              @click:append.stop="timeMenu = true"
            />
          </div>
        </template>

        <!-- Time Picker Panel -->
        <v-card style="max-width: 320px;">
          <v-card-text>
            <div class="time-picker call-filter-time-picker">
              <div class="time-block">
                <p class="mb-2 text-caption">
                  <v-icon small>mdi-information-outline</v-icon> 
                  日付範囲を選択してください。未選択の場合は、現在の日付が自動的に適用されます。</p>
                <label>開始時刻</label>
                <div class="time-row">
                  <input
                    :value="fromHour"
                    type="number"
                    min="0"
                    max="23"
                    class="time-input"
                    hide-details
                    @input="validateTime($event, 'fromHour')"
                    @focus="onFocus('fromHour', 'isFromHourFocused')"
                    @blur="onBlur('fromHour', 'isFromHourFocused')"
                  />
                  :
                  <input
                    type="number"
                    :value="fromMinute"
                    min="0"
                    max="59"
                    class="time-input"
                    @input="validateTime($event, 'fromMinute')"
                    @focus="onFocus('fromMinute', 'isFromMinuteFocused')"
                    @blur="onBlur('fromMinute', 'isFromMinuteFocused')"
                  />
                </div>
              </div>
              <div class="time-block">
                <label>終了時刻</label>
                <div class="time-row">
                  <input
                    :value="toHour"
                    type="number"
                    min="0"
                    max="23"
                    class="time-input"
                    hide-details
                    @input="validateTime($event, 'toHour')"
                    @focus="onFocus('toHour', 'isToHourFocused')"
                    @blur="onBlur('toHour', 'isToHourFocused')"
                  />
                  <div class="hour-min">:</div>
                  <input
                    :value="toMinute"
                    type="number"
                    min="0"
                    max="59"
                    class="time-input"
                    hide-details
                    @input="validateTime($event, 'toMinute')"
                    @focus="onFocus('toMinute', 'isToMinuteFocused')"
                    @blur="onBlur('toMinute', 'isToMinuteFocused')"
                  />
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="timeMenuCancel">キャンセル</v-btn>
            <v-btn color="primary" text @click="applyTime">適用</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-menu
        v-if="field.model == 'call_length'"
        v-model="durationMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <!-- Input to show selected time range -->
        <template v-slot:activator="{ on, attrs }">
          <div
            class="v-input__control"
            @click="handleInputControlClickDurationRange"
          >
            <v-text-field
              v-model="displayDurationRange"
              label="通話時間"
              readonly
              v-bind="attrs"
              v-on="on"
              class="call-filter-input time-range"
              :append-icon="showDurationIcon ? 'mdi-timer-sand' : ''"
              dense
              outlined
              hide-details
              clearable
              @click:clear="clearTimeRange('duration')"
              @click:append.stop="durationMenu = true"
            />
          </div>
        </template>

        <!-- Time Picker Panel -->
        <v-card>
          <v-card-text>
            <div class="time-picker call-filter-time-picker">
              <div class="time-block">
                <label>最小時間</label>
                <div class="time-row">
                  <input
                    :value="durationFromHour"
                    type="number"
                    min="0"
                    max="23"
                    class="time-input"
                    hide-details
                    @input="validateTime($event, 'durationFromHour')"
                    @focus="
                      onFocus('durationFromHour', 'isDurationFromHourFocused')
                    "
                    @blur="
                      onBlur('durationFromHour', 'isDurationFromHourFocused')
                    "
                  />
                  :
                  <input
                    :value="durationFromMinute"
                    type="number"
                    min="0"
                    max="59"
                    class="time-input"
                    hide-details
                    @input="validateTime($event, 'durationFromMinute')"
                    @focus="
                      onFocus(
                        'durationFromMinute',
                        'isDurationFromMinuteFocused'
                      )
                    "
                    @blur="
                      onBlur(
                        'durationFromMinute',
                        'isDurationFromMinuteFocused'
                      )
                    "
                  />
                </div>
              </div>
              <div class="time-block">
                <label>最大時間</label>
                <div class="time-row">
                  <input
                    :value="durationToHour"
                    type="number"
                    min="0"
                    max="23"
                    class="time-input"
                    hide-details
                    @input="validateTime($event, 'durationToHour')"
                    @focus="
                      onFocus('durationToHour', 'isDurationToHourFocused')
                    "
                    @blur="onBlur('durationToHour', 'isDurationToHourFocused')"
                  />
                  <div class="hour-min">:</div>
                  <input
                    :value="durationToMinute"
                    type="number"
                    min="0"
                    max="59"
                    class="time-input"
                    hide-details
                    @input="validateTime($event, 'durationToMinute')"
                    @focus="
                      onFocus('durationToMinute', 'isDurationToMinuteFocused')
                    "
                    @blur="
                      onBlur('durationToMinute', 'isDurationToMinuteFocused')
                    "
                  />
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn text @click="timeMenu = false">Clear</v-btn> -->
            <v-btn text @click="durationMenuCancel(false)">キャンセル</v-btn>
            <v-btn color="primary" text @click="applyDurationRange">適用</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-col>

    <img
      :src="closeIcon"
      alt="close"
      @click="openFilter"
      class="cursor-pointer"
    />
  </v-row>
</template>

<script>
import closeIcon from "@/assets/images/Vector.svg";
export default {
  name: "FilterFields",
  props: {
    filters: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localFilters: { ...this.filters },
      closeIcon,
      // date range picker
      menu: false,
      range: [],
      displayDate: "",
      showCalendarIcon: true,
      showTimerIcon: true,
      showDurationIcon: true,
      startTime: "",
      endTime: "",
      timeMenu: false,
      fromHour: "00",
      fromMinute: "00",
      toHour: "00",
      toMinute: "00",
      displayTimeRange: "",
      durationMenu: false,
      durationFromHour: "00",
      durationFromMinute: "00",
      durationToHour: "00",
      durationToMinute: "00",
      displayDurationRange: "",
      snackbar: false,
      text: ``,
      fromMinuteError: "",
      isFromHourFocused: false,
      isFromMinuteFocused: false,
      isToHourFocused: false,
      isToMinuteFocused: false,
      isDurationFromHourFocused: false,
      isDurationFromMinuteFocused: false,
      isDurationToHourFocused: false,
      isDurationToMinuteFocused: false,
      closedBy: null,
    };
  },
  watch: {
    localFilters: {
      handler(newVal) {
        this.$emit("change", newVal);
      },
      deep: true,
    },
  },

  emits: ["openFilter", "change"],

  methods: {
    emitChange() {
      this.$emit("change", this.localFilters);
    },
    openFilter() {
      this.$emit("openFilter");
    },
    handleInputControlClickTimeRange() {
      this.timeMenu = true;
    },
    handleInputControlClickDate() {
      this.menu = true;
    },
    handleInputControlClickDurationRange() {
      this.durationMenu = true;
    },
    updateRange(val) {
      if (val.start && val.end) {
        this.formattedRange = `${val.start} to ${val.end}`;
      } else {
        this.formattedRange = "";
      }
    },
    durationMenuCancel(type) {
      (this.durationMenu = type), (this.showDurationIcon = true);
    },
    onMenuChange(val) {
      if (!val) {
        this.updateDisplayConfirm();
      }
    },
    cancelMenu() {
      this.menu = false;
    },
    async applyDate() {
      this.menu = false;
      this.updateDisplayConfirm();
    },
    onTimeMenuChange(val) {
      if (!val) {
        this.applyTimeRange();
      }
    },
    timeMenuCancel() {
      this.timeMenu = false;
    },
    async applyTime() {
      this.timeMenu = false;
      this.applyTimeRange();
    },
    updateDisplayConfirm() {
      if (this.range[0] || this.range[1]) {
        if (this.range[0] && !this.range[1]) {
          this.range[1] = this.range[0];
          let date = { start_date: this.range[0], end_date: this.range[0] };
          this.$set(this.localFilters, "date", date);
          this.$emit("change", { ...this.localFilters, date });
          this.menu = false;
          this.clearTimeRange("time");
        } else if (this.range[0] && this.range[1]) {
          let date = { start_date: this.range[0], end_date: this.range[1] };
          this.$set(this.localFilters, "date", date);
          this.$emit("change", { ...this.localFilters, date });
          this.menu = false;
          this.range[0] === this.range[1] && this.clearTimeRange("time");
        } else {
          this.menu = false;
          this.$toast.show(
            "エラーが発生しました。",
            "error",
            2000,
            "date-range-err"
          );
        }
      }
    },
    updateDisplay(dates) {
      if (this.range.length === 2) {
        const fromDate = dates[0];
        const toDate = dates[1];

        if (new Date(toDate) < new Date(fromDate)) {
          this.$toast.show(
            "終了日は開始日より後の日付を選択してください。",
            "error",
            2000,
            "date-range-err"
          );

          this.range = [fromDate, null];
          this.displayDate = fromDate;
          return;
        } else {
          this.snackbar = false;
          this.text = "";
          this.range = dates;
          this.displayDate = `${fromDate} ~ ${toDate}`;
          this.showCalendarIcon = false;
          this.$nextTick(() => {
            const titleBtn = document.querySelector(
              ".v-picker__title__btn.v-date-picker-title__date"
            );
            if (titleBtn) {
              titleBtn.textContent = this.displayDate;
            }
          });
        }
      } else if (this.range.length === 1) {
        // ✅ handle single date
        const fromDate = dates[0];
        this.displayDate = fromDate;
        this.showCalendarIcon = false;
      } else {
        this.displayDate = "";
        this.showCalendarIcon = true;
      }
    },
    clearDateRange() {
      this.clearTimeRange("time");
      this.range = [];
      this.displayDate = "";
      this.emitChange();
      this.range = [];

      // Clear the internal date picker title
      this.$nextTick(() => {
        const titleBtn = document.querySelector(
          ".v-picker__title__btn.v-date-picker-title__date"
        );
        if (titleBtn) {
          titleBtn.textContent = "Select dates"; // Or empty string if you want
        }
      });
      this.showCalendarIcon = true;

      let date = { start_date: "", end_date: "" };
      this.$set(this.localFilters, "date", date);
      this.$emit("change", { ...this.localFilters, date });
    },
    clearTimeRange(type) {
      if (type == "time") {
        this.displayTimeRange = "";
        (this.fromHour = "00"),
          (this.fromMinute = "00"),
          (this.toHour = "00"),
          (this.toMinute = "00");

        let call_time = {
          start_date: "",
          end_date: "",
        };
        this.$set(this.localFilters, "call_time", call_time);
        this.$emit("change", { ...this.localFilters, call_time });
        this.showTimerIcon = true;
      } else {
        (this.durationFromHour = "00"),
          (this.durationFromMinute = "00"),
          (this.durationToHour = "00"),
          (this.durationToMinute = "00"),
          (this.displayDurationRange = "");
        let call_length = {
          start: "",
          end: "",
        };
        this.$set(this.localFilters, "call_length", call_length);

        this.$emit("change", { ...this.localFilters, call_length });
        this.showDurationIcon = true;
      }
      // this.emitChange();
    },
    applyTimeRange() {
      let tempValues = {
        fromHour: this.fromHour,
        fromMinute: this.fromMinute,
        toHour: this.toHour,
        toMinute: this.toMinute,
      };
      const fromTotalMinutes =
        Number(tempValues.fromHour) * 60 + Number(tempValues.fromMinute);
      const toTotalMinutes =
        Number(tempValues.toHour) * 60 + Number(tempValues.toMinute);

      if (
        fromTotalMinutes >= toTotalMinutes &&
        (this.fromHour > 0 ||
          this.fromMinute > 0 ||
          this.toHour > 0 ||
          this.toMinute > 0) &&
        (!this.displayDate ||
          !this.displayDate.includes(" ~ ") ||
          this.displayDate.split(" ~ ")[0] === this.displayDate.split(" ~ ")[1])
      ) {
        this.$toast.show(
          "開始時刻は終了時刻より前にしてください。",
          "error",
          2000,
          "time-range"
        );
        this.showTimerIcon = true;

        // this.snackbar = true;
        // this.text = `"From" time must be less than "To" time.`;
        return;
      } else if (fromTotalMinutes > 0 && toTotalMinutes > 0) {
        let call_time = {
          start_date: `${String(this.fromHour).padStart(2, "0")}:${String(
            this.fromMinute
          ).padStart(2, "0")}`,
          end_date: `${String(this.toHour).padStart(2, "0")}:${String(
            this.toMinute
          ).padStart(2, "0")}`,
        };
        this.$set(this.localFilters, "call_time", call_time);
        this.$emit("change", { ...this.localFilters, call_time });
        this.showTimerIcon = false;
      }
      if (
        this.fromHour > 0 ||
        this.fromMinute > 0 ||
        this.toHour > 0 ||
        this.toMinute > 0
      ) {
        this.displayTimeRange = `${this.pad(this.fromHour)}:${this.pad(
          this.fromMinute
        )} to ${this.pad(this.toHour)}:${this.pad(this.toMinute)}`;
      }
      this.timeMenu = false;
    },
    clearDurationRange() {
      this.displayDurationRange = "";
      (this.durationFromHour = "00"),
        (this.durationFromMinute = "00"),
        (this.durationToHour = "00"),
        (this.durationToMinute = "00");
    },
    applyDurationRange() {
      let tempValues = {
        durationFromHour: this.durationFromHour,
        durationFromMinute: this.durationFromMinute,
        durationToHour: this.durationToHour,
        durationToMinute: this.durationToMinute,
      };
      const fromTotalMinutes =
        Number(tempValues.durationFromHour) * 60 +
        Number(tempValues.durationFromMinute);
      const toTotalMinutes =
        Number(tempValues.durationToHour) * 60 +
        Number(tempValues.durationToMinute);

      if (
        fromTotalMinutes >= toTotalMinutes &&
        (this.durationFromHour > 0 ||
          this.durationFromMinute > 0 ||
          this.durationToHour > 0 ||
          this.durationToMinute > 0)
      ) {
        this.$toast.show(
          "開始時刻は終了時刻より前にしてください。",
          "error",
          2000,
          "duration-range"
        );
        this.showDurationIcon = true;
        // this.snackbar = true;
        // this.text = `"From" time must be less than "To" time.`;
        return;
      } else if (toTotalMinutes > 0) {
        let call_length = {
          start: fromTotalMinutes,
          end: toTotalMinutes,
        };
        this.$set(this.localFilters, "call_length", call_length);

        this.$emit("change", { ...this.localFilters, call_length });
        this.showDurationIcon = false;
      }
      if (
        this.durationFromHour > 0 ||
        this.durationFromMinute > 0 ||
        this.durationToHour > 0 ||
        this.durationToMinute > 0
      ) {
        this.displayDurationRange = `${this.pad(
          this.durationFromHour
        )}:${this.pad(this.durationFromMinute)} to ${this.pad(
          this.durationToHour
        )}:${this.pad(this.durationToMinute)}`;
      }
      this.durationMenu = false;
    },
    pad(val) {
      val = parseInt(val);
      return val < 10 ? "0" + val : val;
    },
    validateTime(event, type) {
      let val = event.target.value;
      let numVal = Number(val);
      let maxVal = type.toLowerCase().includes("hour") ? 23 : 59;
      // If empty, set the property to empty string
      if (val === "" || val <= 0) {
        this[type] = "";
        return;
      }
      // Validation check
      if (
        numVal > maxVal &&
        type != "durationFromHour" &&
        type != "durationToHour"
      ) {
        const displayUnit = type.toLowerCase().includes("hour")
          ? "Hour"
          : "Minute";
        this.$toast.show(
          `${
            type.toLowerCase().includes("hour")
              ? "時は24未満にしてください。"
              : "分は60未満にしてください。"
          } `,
          "error",
          2000,
          displayUnit
        );
        // Revert to previous valid value
        event.target.value = this[type];
        return;
      }

      // Save the value dynamically
      this[type] = val;
    },
    onFocus(valueKey, focusKey) {
      if (this[valueKey] === "00") {
        this[valueKey] = "";
      }
      this[focusKey] = true;
    },
    onBlur(valueKey, focusKey) {
      if (this[valueKey] === "") {
        this[valueKey] = "00";
      }
      this[focusKey] = false;
    },
  },
};
</script>

<style scoped>
.v-date-picker {
  font-size: 12px;
}

.v-date-picker-table .v-btn {
  font-size: 12px;
  height: 28px;
  width: 28px;
  line-height: 28px;
}

.v-date-picker-header {
  font-size: 14px;
}
.time-picker {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.time-block {
  display: flex;
  flex-direction: column;
}
.time-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.time-input {
  width: 100%;
  padding: 4px 8px;
}
</style>
